let percentages = {
  player_load: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  accum_accel_loads: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  mech_loads: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  physio_loads: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  distance: {
    upper: 0.5,
    middle: 999, //unset
    lower: 0.3,
  },
  sprint_distance: {
    upper: 0.66,
    middle: 0.5,
    lower: 0.3,
  },
  high_speed_running: {
    upper: 0.66,
    middle: 0.5,
    lower: 0.3,
  },
  high_speed_running_rel: {
    upper: 0.66,
    middle: 0.5,
    lower: 0.3,
  },
  top_speed: {
    upper: 0.95,
    middle: 999, //unset
    lower: 0.87,
  },
  distance_per_minute: {
    upper: 0.87,
    middle: 999, //unset
    lower: 0.6,
  },
  accel_decel: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  hard_runs: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  accel: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  decel: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  impacts: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  jumps: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  accel_max: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  decel_max: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  sprints: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  max_sprints: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  sprints_90: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  sprints_95: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  distance_no_zones: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  accel_loads: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  decel_loads: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  RPE: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  session_RPE: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.35,
  },
  trimp_per_minute: {
    upper: 0.85,
    middle: 999, //unset
    lower: 0.7,
  },
  trimp: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  time_in_redzone: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  max_hr: {
    upper: 0.9,
    middle: 999, //unset
    lower: 0.8,
  },
  mean_hr: {
    upper: 0.9,
    middle: 999, //unset
    lower: 0.8,
  },
  mood: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  muscle_soreness: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  stress_level: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  hrs_sleep: {
    upper: 0.624,
    middle: 999, //unset
    lower: 0.501,
  },
  performance: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  intensity: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  on_ice_load: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  oil_per_minute: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  high_intensity_work_duration: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  pace_80_max_vel: {
    upper: 0.66,
    middle: 999, //unset
    lower: 0.33,
  },
  z6_distance: {
    upper: 0.66,
    middle: 0.5,
    lower: 0.3,
  },
  z4_z6_distance: {
    upper: 0.66,
    middle: 0.5,
    lower: 0.3,
  },
  dsl: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  z6_entries: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  hmld: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  accelerations_z6: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  decelerations_z6: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  player_load_per_minute: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  load_2d: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  avg_accel_load: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  active_time_in_minutes: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  hia: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  total_dives: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  dives_right: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  dives_left: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  dives_center: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ima_jump_count: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ima_jump_height: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ima_accel: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ima_decel: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ima_cod_left: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ima_cod_right: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ttf_high: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ttf_med: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  ttf_low: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  explosive_efforts: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  cardio_load: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  muscle_load: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  high_effort_yards: {
    upper: 0.65,
    middle: 999, //unset
    lower: 0.35,
  },
  recovery_score: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  hrv_score: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  rhr: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  respiration_rate: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  body_temp: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  readiness_score: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  pre_weight: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  post_weight: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  lost_2lbs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  body_fat: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  menstrual: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  fluid_consumed: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  urine_color: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  activation: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  meals_today: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  calories_consumed: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_gradient: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_hours: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_quality: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  deep_sleep: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  rem_sleep: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  light_sleep: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  awake_sleep: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  mood_gradient: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  mood_number: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  stress_gradient: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  academic_stress: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  fatigue_level: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  soreness_gradient: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  feeling_gradient: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  mood_describe: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_six: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  stress_describe: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  fatigue: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  urine: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  soreness: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  ready_train: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  general_health: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_minutes: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_six_2: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_mt: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  stress_mt: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  soreness_mt: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  love_soccer: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  nutrition: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  sleep_seven: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  stress_seven: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  fatigue_seven: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  soreness_seven: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  connection: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  joint_soreness: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  energy_six: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  nap_duration: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_band_1_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_band_2_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_band_3_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_band_4_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_band_5_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_band_3_5_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  distance_3_5: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  player_load_avg: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  high_velocity_yardage: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  training_effect: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  aerobic_training_effect: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  anaerobic_training_effect: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  epoc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  acute_training_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  chronic_training_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  high_ima_count: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  accel_decel_per_minute: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  work_ratio: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  calories: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_hr_percent: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  avg_hr_percent: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  hrv: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_gt_85_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_80_85_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_70_79_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_50_69_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_gt_85_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_80_85_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_70_79_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  max_velo_50_69_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  }, 
  accel_load_per_minute: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  decel_load_per_minute: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  movement_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  custom_acwr: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  explosive_distance: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  explosive_distance_rel: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  speed_intensity: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  hmld_per_minute: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  hml_efforts: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  avg_time_since_last_hml_effort: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  dynamic_stress_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  }, 
  fatigue_index: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  top_speed_percent: {
    upper: 0.95,
    middle: 999, //unset
    lower: 0.87,
  },
  inertial_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  gk_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  average_gk_power: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  gk_impacts: {
    upper: 0.65,
    middle: 999,
    lower: 0.35,
  },
  ima_total: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_0_60_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_60_75_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_75_85_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_75_85_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_85_90_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_85_90_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_90_95_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_90_95_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_gt_95_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_gt_95_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  throw_count: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  hre: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_50_60: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_60_70: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_70_80: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_80_90: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_90_100: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_100_110: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_gt_110: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  max_hr_perc_gt_120: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  training_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  power_plays: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_gt_85_effs: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_distance_gt_85_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  gps_load: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  accel_decel_gt_2: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  accel_decel_gt_3: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  top_v: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  trimp_per_playerload: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  high_speed_dist_gt_95_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  high_speed_dist_85_95_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  ima_cod_total: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  high_speed_dist_gt_75_perc: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  ima_total_avg: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  total_jumps: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  jumps_med_avg: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  player_load_high_avg: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  metabolic_power: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  explosive_ratio: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  jumps_per_minute: {
    upper: 0.65,
    middle: 999,
    lower: 0.35
  },
  days_since_85: {
    upper:.66,
    middle:999,
    lower:.35
  },
  days_since_x_top_speed: {
    upper:.66,
    middle:999,
    lower:.35
  }
  
};
export const getPercentages = (metricName) => {
  return (
    percentages[metricName] ?? {
      upper: 0.65,
      middle: 999, //unset
      lower: 0.35,
    }
  );
};
export default percentages;
